package com.devi3east.bashbuddy.ktor.stripe.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.common.util.UrlOpener
import com.devi3east.bashbuddy.ktor.stripe.domain.StripeRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class StripeViewModel(
    private val urlOpener: UrlOpener,
    private val repository: StripeRepository,
    private val tokenProvider: () -> String?
) : ViewModel() {

    private val _uiState = MutableStateFlow(StripeUiState())
    val uiState: StateFlow<StripeUiState> = _uiState

    fun stripeOnboarding(email: String) {
        val token = tokenProvider() ?: return
        viewModelScope.launch {
            _uiState.update {
                it.copy(isLoading = true, errorMessage = null)
            }
            val accountResult = repository.createConnectedAccount(token, email)
            accountResult.onSuccess { accountId ->
                _uiState.update { current ->
                    current.copy(accountId = accountId)
                }
                val onboardingResult = repository.createAccountOnboardingLink(token, accountId)
                onboardingResult.onSuccess { url ->
                    _uiState.update { current ->
                        current.copy(onboardingUrl = url)
                    }
                    urlOpener.openUrl(url)
                }.onFailure { error ->
                    _uiState.update { current ->
                        current.copy(errorMessage = error.message ?: "Failed to get onboarding link")
                    }
                }
            }.onFailure { error ->
                _uiState.update { current ->
                    current.copy(errorMessage = error.message ?: "Failed to create Stripe account")
                }
            }
            _uiState.update {
                it.copy(isLoading = false)
            }
        }
    }

    fun resumeStripeOnboarding(accountId: String) {
        val token = tokenProvider() ?: return
        viewModelScope.launch {
            _uiState.update {
                it.copy(isLoading = true, errorMessage = null)
            }
            val onboardingResult = repository.createAccountOnboardingLink(token, accountId)
            onboardingResult.onSuccess { url ->
                _uiState.update { current ->
                    current.copy(onboardingUrl = url)
                }
                urlOpener.openUrl(url)
            }.onFailure { error ->
                _uiState.update { current ->
                    current.copy(errorMessage = error.message ?: "Failed to resume onboarding")
                }
            }
            _uiState.update {
                it.copy(isLoading = false)
            }
        }
    }

    fun openUrl(url: String) {
        urlOpener.openUrl(url)
    }

    fun loadStripeAccount() {
        val token = tokenProvider() ?: return

        viewModelScope.launch {
            _uiState.update {
                it.copy(
                    isLoading = true,
                    errorMessage = null
                )
            }

            try {
                repository.getStripeAccountWithDashboard(token)
                    .onSuccess { result ->
                        val account = result.account

                        _uiState.update {
                            it.copy(
                                accountId = account.accountId,
                                dashboardUrl = result.dashboardUrl,
                                onboardingComplete = account.onboardingComplete,
                                currentlyDue = account.currentlyDue,
                                eventuallyDue = account.eventuallyDue
                            )
                        }
                    }
                    .onFailure { e ->
                        _uiState.update {
                            it.copy(
                                errorMessage = e.message ?: "Failed to load Stripe account"
                            )
                        }
                    }
            } finally {
                _uiState.update {
                    it.copy(isLoading = false)
                }
            }
        }
    }

    fun clearStripeState() {
        _uiState.value = StripeUiState()
    }

}

// EVERYTHING BELOW THIS LINE IS FOR OAUTH SETUP //


/*
package com.devi3east.bashbuddy.ktor.stripe.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.common.util.UrlOpener
import com.devi3east.bashbuddy.ktor.stripe.domain.StripeRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class StripeViewModel(
    private val urlOpener: UrlOpener,
    private val repository: StripeRepository,
    private val tokenProvider: () -> String?
) : ViewModel() {

    private val _uiState = MutableStateFlow(StripeUiState())
    val uiState: StateFlow<StripeUiState> = _uiState

    fun connectStripe(orgId: String) {
        val token = tokenProvider()
        if (token.isNullOrBlank()) return

        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, errorMessage = null) }

            val result = repository.getStripeOAuthUrl(token, orgId)

            result.onSuccess { url ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        hasLoaded = true,
                        onboardingComplete = false
                    )
                }

                urlOpener.openUrl(url)
            }.onFailure { error ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        errorMessage = error.message ?: "Failed to start Stripe connection"
                    )
                }
            }
        }
    }

    fun openUrl(url: String) {
        try {
            urlOpener.openUrl(url)
        } catch (e: Exception) {
            _uiState.update { it.copy(errorMessage = e.message) }
        }
    }

    fun loadStripeAccount(orgId: String) {
        val token = tokenProvider()
        if (token.isNullOrBlank()) return

        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, errorMessage = null) }

            val result = repository.getStripeAccountWithDashboard(token, orgId)

            result.onSuccess { account ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        hasLoaded = true, // ✅ critical

                        accountId = account.accountId,
                        dashboardUrl = account.dashboardUrl,
                        onboardingComplete = account.onboardingComplete,
                        currentlyDue = account.currentlyDue,
                        eventuallyDue = account.eventuallyDue
                    )
                }
            }.onFailure { e ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        hasLoaded = true, // still mark loaded
                        errorMessage = e.message
                    )
                }
            }
        }
    }

    fun clearStripeState() {
        _uiState.value = StripeUiState()
    }

}*/
